export default __webpack_public_path__ + "static/media/testimonial-image7.c278c15a.jpeg";